import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setPageTitle } from '../../utils/pageTitle.utils';

export default function PageTitle() {
	const { pathname } = useLocation();

	useEffect(() => {
		setPageTitle(pathname);
	}, [pathname]);

	return null;
}
